export default __webpack_public_path__ + "static/media/android-icon.111dbb55.svg";